import { useEffect } from 'react';
import { Button, Typography } from 'mobily-ui-library/lib';
import './SuccessModal.scss';

interface Props {
    id: string;
    rtl: boolean;
    title: string;
    description: string;
    buttonText: string;
    modalButtonClick: () => void;
    imgSrc?: string;    
}

function SuccessModal({
    id,
    rtl,
    title,
    description,
    buttonText,
    modalButtonClick,
    imgSrc
}: Props) {

    useEffect(() => {
        document.body.style.overflow = 'hidden';
    }, []);

    return (
        <div className={rtl ? 'Success__ModalContainer Success__ModalRight' : 'Success__ModalContainer'}>
            <div className='Success__Fallback'></div>

            <div className='Success__Modal' id={id}>
                
                {imgSrc && (
                    <img src={imgSrc} alt="success-icon" className="Success__Image" />
                )}

                <Typography rtl={rtl} className='Success__MT'>{title}</Typography>
                <Typography rtl={rtl} className='Success__MST'>{description}</Typography>

                <Button rtl={rtl} className='Success__Button' onClick={modalButtonClick}>
                    {buttonText}
                </Button>

            </div>
        </div>
    );
}

export default SuccessModal;
